import { gql } from '@apollo/client';

import {
  COMPONENT_STYLES_FRAGMENT,
  CTA_BUTTON_GROUP_FIELDS,
  FAQS_LIST_FRAGMENT,
  MEDIA_FRAGMENT,
  NBJ_COMPOSE_PAGES_FRAGMENT,
  PLAN_DETAILS,
  PRODUCT_GROUP,
  QUICK_PRODUCT_GROUP,
} from '../fragments/composePage';

export const getComposePages = gql`
  ${NBJ_COMPOSE_PAGES_FRAGMENT}
  query getComposePage($usePreview: Boolean, $slug: String) {
    NBJComposePages(usePreview: $usePreview, slug: $slug) {
      ...NBJComposePagesFragment
    }
  }
`;

export const getEntityDetails = gql`
  query getNBJEntityDetails($usePreview: Boolean, $id: String!) {
    NBJEntityDetails(usePreview: $usePreview, id: $id) {
      internalName
      title
      contentModelType
      fields
      sys
    }
  }
`;

export const getHeroBannerDetails = gql`
  ${MEDIA_FRAGMENT}
  query getHomeCarouselDetails($usePreview: Boolean, $id: String!) {
    bannerData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      internalName
      classNameReference
      headingH
      titleH
      contentModelType
      autoPlay
      isScrollBtnEnabled
      playBackLoop
      ${COMPONENT_STYLES_FRAGMENT}
      contentModels {
        fields {
          classNameReference
          contentModelType
          headingH
          titleH
          description
          shortOfInformation
          alignmentOfVideoImage
          layoutOption
          ${CTA_BUTTON_GROUP_FIELDS}
          synopsesImages {
            ...MediaFragment
          }
          productCards {
            fields {
              ${PLAN_DETAILS}
            }
            sys {
              id
            }
          }
          imageDesktop {
            ...MediaFragment
          }
          imageMobile {
            ...MediaFragment
          }
          brightCoverVideoIdMobile
          brightCoverVideoIdDesktop
          testHeaders
        }
        sys {
          id
        }
      }
    }
  }
`;

export const getFaqsDetails = gql`
  ${FAQS_LIST_FRAGMENT}
  query getFAQSDetails($usePreview: Boolean, $id: String!) {
    faqData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      headingH
      titleH
      description
      faqsList {
        ...FaqListFragment
      }
     ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getDeviceDetails = gql`
  ${MEDIA_FRAGMENT}
  query getDeviceDetails($usePreview: Boolean, $id: String!) {
    deviceData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      titleH
      headingH
      contentModels {
        fields {
          headingH
          titleH
          alignmentOfVideoImage
          alignmentOfInfoContent
          description
          shortOfInformation
          ${CTA_BUTTON_GROUP_FIELDS}
          imageDesktop {
           ...MediaFragment
          }
          imageMobile {
          ...MediaFragment
          }
          imageTablet {
          ...MediaFragment
          }
          synopsesImages {
            ...MediaFragment
          }
          productCards {
            fields {
              ${PLAN_DETAILS}
            }
            sys {
              id
            }
          }
        }
        sys {
         id
        }  
      }
     ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getFeatureDetails = gql`
  ${MEDIA_FRAGMENT}
  query getFeatureDetails($usePreview: Boolean, $id: String!) {
    featureData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      contentModelType
      headingH
      titleH
      description
      showCarouselView
      contentModels {
        fields {
          headingH
          titleH
          description
          alignmentOfInfoContent
          alignmentOfVideoImage
         imageDesktop {
         ...MediaFragment
         }
         imageMobile {
         ...MediaFragment
         }
        }
        sys {
         id
        }
      }
    ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getTestimonialDetails = gql`
  ${MEDIA_FRAGMENT}
query getHomeCarouselDetails($usePreview: Boolean, $id: String!) {
  NBJComponentDetails(usePreview: $usePreview, id: $id) {
    internalName
    classNameReference
    headingH
    titleH
    ${COMPONENT_STYLES_FRAGMENT}
    showCarouselView
    contentModels {
      fields {
        firstName
        lastName
        shortDetails
        shortOfInformation
        rating
        profileImage {
          ...MediaFragment
        }
          description
      }
      sys {
        id
      }
    }
  }
}
`;

export const getPromosectionDetails = gql`
  ${MEDIA_FRAGMENT}
  query getPromoSectionDetails($usePreview: Boolean, $id: String!) {
    promosectionData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      contentModelType
      headingH
      titleH
      shortOfInformation
      alignmentOfVideoImage
      description
      ${COMPONENT_STYLES_FRAGMENT}
      layoutOption
      ${CTA_BUTTON_GROUP_FIELDS}
      synopsesImages {
         ...MediaFragment
      }
      imageDesktop {
        ...MediaFragment
      }
      imageMobile {
        ...MediaFragment
      }
    }
  }
`;

export const getRailTabsSectionDetails = gql`
  ${MEDIA_FRAGMENT}
  query getRailTabsSectionDetails($usePreview: Boolean, $id: String!) {
    railsTabData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      headingH
      titleH
      description
      layoutOption
      tabsColorVariant
      members {
        sys{
            id
          }
        fields {
          internalName
          name
          railType
          contentRails
          moreInfo
          catalogMembers{
            fields{
              customSynopses
              catalogId
            }
            sys{
            id
            }
          }
          members {
             fields {
                title
                description

                image {
                  ...MediaFragment
                }
                landscapeImage {
                 ...MediaFragment
                } 
                 synopsesImages {
                  ...MediaFragment
                  __typename
                } 
                slugurl
                shortOfInformation
             }
            sys{
            id
            }
          }
        }
      }
    ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getBundlePlansDetails = gql`
${MEDIA_FRAGMENT}
  query getBundleSectionDetails($usePreview: Boolean, $id: String!) {
    bundleData: NBJChildEntityComponentDetails(usePreview: $usePreview, id: $id) {
      internalName
      members {
        fields {
          ${PLAN_DETAILS}
          ${PRODUCT_GROUP}
        }
        sys {
          id
        }
      }
    }
  }
`;

export const getBundlePlansBasedOnTabsSelection = gql`
  query getBundleSectionDetails($usePreview: Boolean, $id: String!) {
    bundleData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      contentModelType
      titleH
      headingH
      description
      layoutOption
      tabsColorVariant
      ${COMPONENT_STYLES_FRAGMENT}
      showCollapseView
      members {
        fields {
          internalName
          name
          members {
            fields {
              internalName
              name
              members {
                fields {
                 internalName
                  name
                }
                sys {
                  id
                }
              }
            }
            sys {
              id
            }
          }
        }
        sys {
          id
        }
      }
    }
  }
`;

export const getBundlePlansQuickCompareList = gql`
  ${MEDIA_FRAGMENT}
  query getBundlePlanQuickDetails($usePreview: Boolean, $id: String!) {
    bundleData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
    legalLine
    termsAndConditionsCaption
      members {
        fields {
          internalName
          name
          members {
            fields {
               ${QUICK_PRODUCT_GROUP}
              members {
                fields {
                  ${QUICK_PRODUCT_GROUP}
                }
                sys {
                  id
                }
              }
            }
            sys {
              id
            }
          }
        }
        sys {
          id
        }
      }
    }
  }
`;

export const getRailOrGridDetails = gql`
   ${MEDIA_FRAGMENT}
  query getRailOrGridDetails($usePreview: Boolean, $id: String!) {
    railsOrGridsData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      headingH
      titleH
      description
      contentModelType
      contentModels {
        fields {
          internalName
          title,
          description
          railType
          contentRails
          moreInfo
          catalogMembers{
            fields{
              customSynopses
              catalogId
            }
            sys{
                id
            }
          }
          images {
            ...MediaFragment
          }
        }
        sys {
          id
        }
      }
      ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getAddressDetails = gql`
  ${MEDIA_FRAGMENT}
  query getAddressDetails($usePreview: Boolean, $id: String!) {
    addressData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      titleH
      headingH
      description
      contentModelType
      synopsesImages {
        ...MediaFragment
      }
      ${CTA_BUTTON_GROUP_FIELDS}
       ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getvideoSectionDetails = gql`
  ${MEDIA_FRAGMENT}
  query getVideoSectionDetails($usePreview: Boolean, $id: String!) {
    videoData: NBJComponentDetails(usePreview: $usePreview, id: $id) {
      classNameReference
      headingH
      titleH
      description
      contentModelType
      showCarouselView
      autoPlay
      isScrollBtnEnabled
      playBackLoop
      contentModels {
        fields {
          headingH
          titleH
          description
          titleImage {
            ...MediaFragment
          }
          alignmentOfVideoImage
          layoutOption
          disableGradientOverlay
          synopsesImages {
            ...MediaFragment
          }
          brightCoverVideoIdMobile
          brightCoverVideoIdDesktop
          imageDesktop {
            ...MediaFragment
          }
          imageMobile {
            ...MediaFragment
          }
          shortOfInformation
           ${CTA_BUTTON_GROUP_FIELDS}
        }
        sys {
          id
        }
      }
     ${COMPONENT_STYLES_FRAGMENT}
    }
  }
`;

export const getProductList = gql`
 ${MEDIA_FRAGMENT}
  query getProductList($usePreview: Boolean, $contentModalName: String!) {
    NBJProductList(usePreview: $usePreview, contentModalName: $contentModalName) {
      fields {
        ${PLAN_DETAILS}
      }
    }
  }
`;

export const getPlanViewDetails = gql`
  ${MEDIA_FRAGMENT}
  query getProductItem($usePreview: Boolean, $id: String!) {
    planData: NBJProductItem(usePreview: $usePreview, id: $id) {
      fields {
        ${PLAN_DETAILS}
      }
      sys {
        id
      }
    }
  }
`;

export const getNBJShowDetailsFromCatalog = gql`
  query getNBJCatalogContentDetails($ids: [ID!]!, $aspectRatio: Float!) {
    experience(appId: SKY_WEB) {
      appId
      __typename
      titles(ids: $ids) {
        __typename
        id
        title
        ... on Show {
          type

          tileImage(aspectRatio: $aspectRatio) {
            uri
          }
          viewingMethods {
            __typename
            ... on LinearViewingMethod {
              packages {
                id
                title
              }
            }
            ... on VodViewingMethod {
              packages {
                id
                title
              }
            }
            ... on DownloadViewingMethod {
              packages {
                id
                title
              }
            }
          }
        }
        ... on Movie {
          __typename
          tileImage(aspectRatio: $aspectRatio) {
            uri
          }
          viewingMethods {
            __typename
            ... on LinearViewingMethod {
              packages {
                id
                title
              }
            }
            ... on VodViewingMethod {
              packages {
                id
                title
              }
            }
            ... on DownloadViewingMethod {
              packages {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const getNBJItemDetails = gql`
  query getNBJItemDetails($ids: [ID!]!) {
    experience(appId: SKY_WEB) {
      appId
      __typename
      titles(ids: $ids) {
        __typename
        id
        title
        ... on Show {
          type
          synopsis(preferLength: LONG)
          numberOfSeasons
          ratingString
          primaryGenres {
            title
          }
        }
        ... on Movie {
          __typename
          ratingString
          primaryGenres {
            title
          }
          duration
          year
          synopsis(preferLength: LONG)
        }
      }
    }
  }
`;

export const getDigitalRailQuery = gql`
  query GetGroup($railId: ID!) {
    experience(appId: SKY_WEB) {
      __typename
      group(id: $railId) {
        id
        title
        subtitle
        aspectRatio
        content {
          __typename
          ... on Show {
            id
            title
            synopsis
            viewingMethods {
              _
              ... on DownloadViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
              ... on LinearViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
              ... on VodViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
            }
            heroImage(aspectRatio: 1.77) {
              uri
            }
            tileImage(aspectRatio: 1.77) {
              uri
            }
            detailImage(aspectRatio: 1.77) {
              uri
            }
          }
          ... on Episode {
            id
            type
            title
            synopsis
            viewingMethods {
              _
              ... on DownloadViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
              ... on LinearViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
              ... on VodViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
            }

            image {
              uri
              hasTitleTreatment
            }
          }
          ... on Movie {
            id
            title
            synopsis
            viewingMethods {
              _
              ... on DownloadViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
              ... on LinearViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
              ... on VodViewingMethod {
                _
                packages {
                  id
                  title
                }
              }
            }
            heroImage(aspectRatio: 1.77) {
              uri
            }
            tileImage(aspectRatio: 1.77) {
              uri
            }
            detailImage(aspectRatio: 1.77) {
              uri
            }
          }
        }
      }
    }
  }
`;

//   query GetGroup(
//     $railId: ID!
//     $sectionId: ID!
//     $appId: AppId!
//     $deviceId: ID
//     $first: Int
//     $after: String
//   ) {
//     experience(appId: $appId) {
//       section(id: $sectionId) {
//         home {
//           ... on ContentHome {
//             path
//             group(id: $railId) {
//               id
//               title
//               subtitle
//               __typename
//               detailLink {
//                 __typename
//                 title
//                 ... on TvGuideDetailLink {
//                   channel {
//                     ... on LinearChannel {
//                       id
//                     }
//                   }
//                 }
//                 ... on CollectionGroupDetailLink {
//                   collection {
//                     id
//                   }
//                 }
//               }
//               aspectRatio
//               ... on ContinueWatchingGroup {
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                   content {
//                     ... on Show {
//                       rating {
//                         classification
//                         advisories
//                       }

//                       ...showDefaultEpisode
//                     }
//                     ... on Movie {
//                       duration
//                       watchProgress {
//                         complete
//                         position
//                       }
//                       asset {
//                         id
//                         hasParentalRestriction
//                       }
//                       ...viewingMethodWithoutOffer
//                     }
//                   }
//                 }
//               }
//               ... on SmallRailGroup {
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                 }
//               }
//               ... on MediumRailGroup {
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                 }
//               }
//               ... on LargeRailGroup {
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                 }
//               }
//               ... on TvGuideRailGroup {
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                 }
//               }
//               ... on FavouriteAppsGroup {
//                 id
//                 presentation
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                 }
//               }
//               ... on FeatureRailGroup {
//                 contentPage {
//                   ...contentPageFragment
//                   content {
//                     ... on Show {
//                       allGenres {
//                         title
//                       }
//                       synopsis
//                       nzBsaRatingString
//                       numberOfSeasons
//                       onMyList
//                       viewingMethods {
//                         ... on LinearViewingMethod {
//                           packages {
//                             id
//                             title
//                           }
//                         }
//                       }
//                       recordingSeriesLinks {
//                         recordRequests(deviceId: $deviceId) {
//                           __typename
//                         }
//                       }
//                       promotedEpisode {
//                         season {
//                           number
//                         }
//                         asset {
//                           __typename
//                         }
//                         duration
//                         number
//                         promotedSlot {
//                           start
//                           end
//                           live
//                           hasMultipleAudioTracks
//                           captionLanguages
//                           channel {
//                             title
//                           }
//                           queuedSlotRecordings(deviceId: $deviceId) {
//                             requests {
//                               __typename
//                             }
//                           }
//                           programme {
//                             __typename
//                             title
//                             synopsis
//                           }
//                         }
//                       }
//                     }
//                     ... on Movie {
//                       synopsis
//                       onMyList
//                       nzBsaRatingString
//                       allGenres {
//                         title
//                       }
//                       duration
//                       year
//                       asset {
//                         __typename
//                       }

//                       viewingMethods {
//                         __typename
//                         ... on TvodViewingMethod {
//                           __typename

//                           tvodOffer {
//                             id
//                             price {
//                               amount
//                             }
//                             startingPeriod
//                             rentalPeriod
//                             expressRelease
//                             purchases {
//                               id
//                               purchasedAt
//                               state
//                               tvodWatchState {
//                                 startedWatchingAt
//                               }
//                             }
//                           }
//                         }
//                       }

//                       promotedSlot {
//                         start
//                         end
//                         live
//                         channel {
//                           title
//                         }
//                         captionLanguages
//                         hasMultipleAudioTracks
//                         queuedSlotRecordings(deviceId: $deviceId) {
//                           requests {
//                             __typename
//                           }
//                         }
//                       }
//                     }
//                     ... on PayPerViewEvent {
//                       synopsis
//                       nzBsaRatingString
//                       onMyList
//                       allGenres {
//                         title
//                       }
//                       promotedEventProgram {
//                         asset {
//                           __typename
//                         }
//                         promotedSlot {
//                           start
//                           end
//                           live
//                           channel {
//                             title
//                           }
//                           captionLanguages
//                           hasMultipleAudioTracks
//                           queuedSlotRecordings(deviceId: $deviceId) {
//                             requests {
//                               __typename
//                             }
//                           }
//                         }
//                       }
//                       ...viewingMethodWithoutOffer
//                     }
//                     ... on CollectionLink {
//                       namedFilters {
//                         id
//                         title
//                       }
//                       bannerText: title
//                       titleImage {
//                         uri
//                       }
//                       tileImage {
//                         uri
//                       }
//                       collection {
//                         id
//                         title
//                         tileImage {
//                           uri
//                         }
//                       }
//                     }
//                     ... on SectionLink {
//                       sectionLinkTitle: title
//                       titleImage {
//                         uri
//                       }
//                       tileImage {
//                         uri
//                       }
//                       section {
//                         sectionTitle: title
//                         home {
//                           ... on ContentHome {
//                             path
//                           }
//                         }
//                       }
//                     }
//                   }
//                 }
//               }

//               ... on OnAirSlotGroup {
//                 contentPage(first: $first, after: $after) {
//                   ...contentPageCommonFragment
//                   content {
//                     __typename
//                     ... on LinearSlot {
//                       id
//                       start
//                       end
//                       programme {
//                         __typename
//                         ... on Program {
//                           title
//                           nzBsaRatingString
//                         }
//                         ... on Episode {
//                           image(type: SHOW_OVERLAY) {
//                             uri
//                             overlayImages {
//                               uri
//                               position
//                             }
//                           }
//                         }
//                       }
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   }

//   fragment viewingMethodWithoutOffer on ViewableContent {
//     viewingMethods {
//       __typename
//       ... on VodViewingMethod {
//         packages {
//           id
//           title
//           mySubscription {
//             __typename
//           }
//         }
//       }
//       ... on LinearViewingMethod {
//         packages {
//           id
//           title
//           mySubscription {
//             __typename
//           }
//         }
//       }
//       ... on PayPerViewViewingMethod {
//         payPerViewOffer {
//           id
//           price {
//             amount
//           }
//           purchases {
//             id
//             purchasedAt
//             state
//           }
//         }
//       }
//       ... on TvodViewingMethod {
//         __typename

//         tvodOffer {
//           id
//           price {
//             amount
//           }
//           startingPeriod
//           rentalPeriod
//           expressRelease
//           purchases {
//             id
//             purchasedAt
//             state
//             tvodWatchState {
//               startedWatchingAt
//             }
//           }
//         }
//       }
//     }
//   }

//   fragment linearChannelTile on LinearChannel {
//     id
//     title
//     tileImage(aspectRatio: 1.77) {
//       uri
//     }
//     slot {
//       start
//       end
//       hasParentalRestriction
//       hasMultipleAudioTracks
//       live
//       rating {
//         classification
//         advisories
//       }
//       programme {
//         __typename
//         ... on Title {
//           id
//           title
//         }
//         ... on Movie {
//           heroImage {
//             uri
//           }
//           primaryGenres {
//             title
//           }
//           year
//         }
//         ... on Episode {
//           id
//           title
//           number
//           season {
//             id
//             number
//           }
//           show {
//             __typename
//             id
//             title
//             type
//             primaryGenres {
//               title
//             }
//             heroImage {
//               uri
//             }
//           }
//         }
//       }
//     }
//     ...viewingMethodWithoutOffer
//   }

//   fragment contentPageFragment on ContentPage {
//     pageInfo {
//       endCursor
//       hasNextPage
//     }
//     content {
//       __typename
//       ... on Title {
//         id
//         title
//       }
//       ... on Show {
//         type
//         id
//         title
//         synopsis
//         heroImage {
//           uri
//         }
//         primaryGenres {
//           title
//         }
//         year
//         numberOfSeasons
//         viewingMethods {
//           __typename
//           ... on VodViewingMethod {
//             packages {
//               id
//               title
//             }
//           }
//           ... on LinearViewingMethod {
//             packages {
//               id
//               title
//             }
//           }
//         }
//       }
//       ... on Movie {
//         title
//         synopsis
//         heroImage {
//           uri
//         }
//         primaryGenres {
//           title
//         }
//         year
//         duration
//         rating {
//           classification
//           advisories
//         }
//         viewingMethods {
//           __typename
//           ... on VodViewingMethod {
//             packages {
//               id
//               title
//             }
//           }
//           ... on LinearViewingMethod {
//             packages {
//               id
//               title
//             }
//           }
//         }
//       }
//       ... on PayPerViewEvent {
//         heroImage {
//           uri
//         }
//       }
//       ... on Episode {
//         __typename
//         id
//         title
//         show {
//           id
//           type
//           heroImage {
//             uri
//           }
//         }
//         season {
//           number
//         }
//         liveEvent {
//           startTime
//           endTime
//         }
//         number
//         duration
//         image(type: SHOW_OVERLAY) {
//           uri
//           overlayImages {
//             uri
//             position
//           }
//         }
//         rating {
//           classification
//           advisories
//         }
//         asset {
//           id
//           hasParentalRestriction
//           instantReplay
//         }
//         promotedSlot {
//           id
//           start
//           end
//           channel {
//             id
//             title
//           }
//         }
//         ...viewingMethodWithoutOffer
//         viewingMethods {
//           ... on VodViewingMethod {
//             dateRange {
//               start
//             }
//           }
//           ... on TvodViewingMethod {
//             dateRange {
//               start
//             }
//           }
//         }
//       }
//       ...linearChannelTile
//       ... on Collection {
//         id
//         title
//         heroImage {
//           uri
//         }
//       }
//       ... on CollectionLink {
//         collection {
//           id
//           title
//           heroImage {
//             uri
//           }
//         }
//         tileImage {
//           uri
//         }
//         namedFilters {
//           id
//           title
//         }
//       }
//       ...boxAppTile
//     }
//   }

//   fragment tileImageFragment on ContentPage {
//     content {
//       ... on Show {
//         tileImage {
//           uri
//           overlayImages {
//             uri
//             position
//           }
//         }
//       }
//       ... on Movie {
//         tileImage {
//           uri
//           overlayImages {
//             uri
//             position
//           }
//         }
//       }
//       ... on Collection {
//         tileImage {
//           uri
//           overlayImages {
//             uri
//             position
//           }
//           hasTitleTreatment
//         }
//       }
//       ... on PayPerViewEvent {
//         tileImage {
//           uri
//           overlayImages {
//             uri
//             position
//           }
//         }
//       }
//     }
//   }

//   fragment boxAppTile on BoxApp {
//     id
//     mandatory
//     favourite
//     lastOpened
//     canUnfavourite
//     suggestedTileImage(aspectRatio: 1.77) {
//       uri
//     }
//   }

//   fragment contentPageCommonFragment on ContentPage {
//     ...contentPageFragment
//     ...tileImageFragment
//   }

//   fragment showDefaultEpisode on Show {
//     defaultEpisode {
//       __typename
//       id
//       title
//       season {
//         number
//       }
//       number
//       image(type: SHOW_OVERLAY) {
//         uri
//       }
//       duration
//       rating {
//         classification
//         advisories
//       }
//       watchProgress {
//         complete
//         position
//       }
//       asset {
//         id
//         hasParentalRestriction
//       }
//       ...viewingMethodWithoutOffer
//     }
//   }
// `;
